export const VIEWER_SCALES = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] as const
export const VIEWER_MIN_SCALE = VIEWER_SCALES[0]
export const VIEWER_MAX_SCALE = VIEWER_SCALES[VIEWER_SCALES.length - 1]
